import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Tan Wei Ling',
  role: 'Owner, Nyonya Delights',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
  quote: "ChefChat has transformed how we handle customer communications. I've reclaimed at least 15 hours per week that I now spend perfecting our laksa recipe instead of answering the same questions repeatedly.",
  stars: 5
}, {
  name: 'Lim Chee Keong',
  role: 'Owner, Golden Wok',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
  quote: "Our customers can't tell the difference between ChefChat and our staff. The AI has mastered our restaurant's unique voice, and the 24/7 availability has increased our reservation bookings by 32%.",
  stars: 5
}, {
  name: 'Priya Gopal',
  role: 'Owner, Spice Garden',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
  quote: 'I was skeptical about using AI for customer service, but ChefChat feels genuinely human. It handles all our social media inquiries and reservation requests flawlessly, even during our busiest times.',
  stars: 5
}];
const SocialProof = () => {
  return <section id="testimonials" className="py-16 bg-cream" data-id="element-338">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-339">
        <div className="text-center mb-16" data-id="element-340">
          <h2 className="text-3xl md:text-4xl font-bold font-display text-charcoal" data-id="element-341">
            Trusted by Restaurant Owners Like You
          </h2>
          <p className="mt-4 text-lg text-sage max-w-2xl mx-auto" data-id="element-342">
            Join hundreds of independent restaurant owners who've reclaimed
            their time and improved customer satisfaction
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-343">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg shadow-md p-6 relative" data-id="element-344">
              <div className="flex items-center mb-4" data-id="element-345">
                {[...Array(testimonial.stars)].map((_, i) => <StarIcon key={i} size={18} className="text-copper fill-copper" data-id="element-346" />)}
              </div>
              <p className="text-charcoal italic mb-6" data-id="element-347">"{testimonial.quote}"</p>
              <div className="flex items-center" data-id="element-348">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-349" />
                <div data-id="element-350">
                  <p className="font-medium text-charcoal" data-id="element-351">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-sage" data-id="element-352">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-16 bg-white rounded-lg shadow-md p-8" data-id="element-353">
          <div className="grid md:grid-cols-4 gap-8 text-center" data-id="element-354">
            <div data-id="element-355">
              <p className="text-3xl font-bold text-burgundy" data-id="element-356">500+</p>
              <p className="text-sm text-sage" data-id="element-357">Restaurants Using ChefChat</p>
            </div>
            <div data-id="element-358">
              <p className="text-3xl font-bold text-burgundy" data-id="element-359">95%</p>
              <p className="text-sm text-sage" data-id="element-360">Customer Satisfaction</p>
            </div>
            <div data-id="element-361">
              <p className="text-3xl font-bold text-burgundy" data-id="element-362">24/7</p>
              <p className="text-sm text-sage" data-id="element-363">Availability</p>
            </div>
            <div data-id="element-364">
              <p className="text-3xl font-bold text-burgundy" data-id="element-365">12hrs+</p>
              <p className="text-sm text-sage" data-id="element-366">Weekly Time Saved</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default SocialProof;